import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  GetAllSectorsUseCaseInterface,
  GetSectorByIdUseCaseInterface,
} from 'domain/usecases';

interface ISectorsState {
  sectors: GetAllSectorsUseCaseInterface.Result;
  selectedSector: GetSectorByIdUseCaseInterface.Result;
}

interface IPayloadSectors
  extends PayloadAction<GetAllSectorsUseCaseInterface.Result> {}

interface IPayloadSelectedSector
  extends PayloadAction<GetSectorByIdUseCaseInterface.Result> {}

const initialState: ISectorsState = {
  sectors: null,
  selectedSector: null,
};

export const SectorsSlice = createSlice({
  name: 'sectors-slice',
  initialState,
  reducers: {
    loadSectors: (state, action: IPayloadSectors) => {
      state.sectors = action.payload;
    },
    clearSectors: (state) => {
      state.sectors = null;
    },
    loadSelectedSector: (state, action: IPayloadSelectedSector) => {
      state.selectedSector = action.payload;
    },
    clearSelectedSector: (state) => {
      state.selectedSector = null;
    },
  },
});

export const {
  loadSectors,
  clearSectors,
  loadSelectedSector,
  clearSelectedSector,
} = SectorsSlice.actions;

export default SectorsSlice.reducer;
